var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('rpl-link',{staticClass:"rpl-button",class:{
    'rpl-button--primary': (_vm.theme === 'primary'),
    'rpl-button--secondary': (_vm.theme === 'secondary'),
    'rpl-button--disabled': _vm.disabled
  },attrs:{"href":_vm.href}},[_vm._t("default")],2):_c('button',{staticClass:"rpl-button",class:{
    'rpl-button--primary': (_vm.theme === 'primary'),
    'rpl-button--secondary': (_vm.theme === 'secondary'),
    'rpl-button--disabled': _vm.disabled
  },attrs:{"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }